module.exports = __webpack_public_path__ + "static/media/backmusic.df76f525.mp3";